module.exports = __webpack_public_path__ + "static/media/Testimonials.bcf3c273.png";